import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collegeService } from '../services/api';
import './Colleges.css';

function CollegeImage({ logo, name }) {
  const [imageError, setImageError] = useState(false);
  const API_BASE_URL = "http://localhost:59844/";
  const logoUrl = logo 
    ? (logo.includes('http') ? logo : `${API_BASE_URL}${logo}`)
    : null;

  if (logoUrl && !imageError) {
    return (
      <img 
        src={logoUrl} 
        alt={name}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={() => setImageError(true)}
      />
    );
  }
  return <div className="college-image-icon">🏛️</div>;
}

function Colleges() {
  const [colleges, setColleges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');

  useEffect(() => {
    loadColleges();
  }, []);

  const loadColleges = async () => {
    try {
      setLoading(true);
      const data = await collegeService.getColleges();
      setColleges(data);
    } catch (error) {
      console.error('Error loading colleges:', error);
      alert('Error loading colleges. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const getLocation = (college) => {
    const parts = [];
    if (college.Location) parts.push(college.Location);
    if (college.District?.Name) parts.push(college.District.Name);
    if (college.State?.Name) parts.push(college.State.Name);
    if (college.Country?.Name) parts.push(college.Country.Name);
    return parts.length > 0 ? parts.join(', ') : 'Location not specified';
  };

  const getCollegeType = (college) => {
    if (college.University?.Name) {
      return college.University.Name;
    }
    return 'College';
  };

  const filteredColleges = colleges.filter(college => {
    const matchesSearch = college.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         getLocation(college).toLowerCase().includes(searchTerm.toLowerCase()) ||
                         college.Code?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterType === 'All' || getCollegeType(college) === filterType;
    return matchesSearch && matchesFilter;
  });

  const uniqueTypes = ['All', ...new Set(colleges.map(c => getCollegeType(c)))];

  if (loading) {
    return (
      <div className="colleges">
        <div className="page-header">
          <div className="container">
            <h1>Colleges</h1>
            <p>Explore our network of partner colleges and universities</p>
          </div>
        </div>
        <div className="container" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Loading colleges...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="colleges">
      <div className="page-header">
        <div className="container">
          <h1>Colleges</h1>
          <p>Explore our network of partner colleges and universities</p>
        </div>
      </div>

      <div className="container">
        <div className="search-filter-section">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search colleges by name, code or location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-buttons">
            {uniqueTypes.map(type => (
              <button 
                key={type}
                className={`filter-btn ${filterType === type ? 'active' : ''}`}
                onClick={() => setFilterType(type)}
              >
                {type}
              </button>
            ))}
          </div>
        </div>

        {filteredColleges.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}>
            <p>No colleges found.</p>
          </div>
        ) : (
          <div className="colleges-grid">
            {filteredColleges.map(college => (
              <Link key={college.Id} to={`/college/${college.Id}`} className="college-card-link">
                <div className="college-card">
                  <div className="college-image">
                    <CollegeImage logo={college.Logo} name={college.Name} />
                  </div>
                  <div className="college-content">
                    <div className="college-header">
                      <h3>{college.Name}</h3>
                      <span className="college-type">{getCollegeType(college)}</span>
                    </div>
                    {college.Code && <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Code: {college.Code}</p>}
                    <p className="college-location">📍 {getLocation(college)}</p>
                    {college.Email && <p style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.5rem' }}>📧 {college.Email}</p>}
                    {college.MobileNo && <p style={{ color: '#666', fontSize: '0.9rem' }}>📞 {college.MobileNo}</p>}
                    {college.Description && (
                      <p style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.5rem', lineHeight: '1.5' }}>
                        {college.Description.length > 100 
                          ? college.Description.substring(0, 100) + '...' 
                          : college.Description}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Colleges;

